import { toast } from 'react-toastify';

import { includes, isEmpty, isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;

    let defParams = {};

    if (isEmpty(params)) {
      defParams = {
        wherefield: ['tipototalizadorveiculo, tipototalizador2veiculo'],
        valuewherefield: [0, 0],
        typewherefield: ['NEQUALS', 'NEQUALS'],
      };
    } else {
      defParams = params;
    }

    const response = yield call(api.get, 'veiculos', {
      params: defParams,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `veiculos/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'veiculos', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/opertotalizadorveiculo');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `veiculos/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'veiculos', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/opertotalizadorveiculo');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const params = {
      wherefield: [],
      valuewherefield: [],
      typewherefield: [],
      ...payload.params,
    };

    if (!includes(params.wherefield, 'tipototalizadorveiculo')) {
      params.wherefield = [...params.wherefield, 'tipototalizadorveiculo'];
      params.valuewherefield = [...params.valuewherefield, 0];
      params.typewherefield = [...params.typewherefield, 'NEQUALS'];
    }

    const response = yield call(api.get, 'veiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@operacaoTotalizadorVeiculo/DATA_IN_REQUEST', requestData),
  takeLatest('@operacaoTotalizadorVeiculo/DELETE_DATA', deleteData),
  takeLatest('@operacaoTotalizadorVeiculo/SUCCESS_REMOVE', requestData),
  takeLatest('@operacaoTotalizadorVeiculo/STORE_DATA', store),
  takeLatest('@operacaoTotalizadorVeiculo/FIND_DATA', find),
  takeLatest('@operacaoTotalizadorVeiculo/UPDATE_DATA', update),
  takeLatest('@operacaoTotalizadorVeiculo/RECORD_FILTERING', applyedFilters),
]);
